const LocalStorageService = (function () {
  var _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function setDataToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  function _setToken(tokenObj) {
    localStorage.setItem("access_token", tokenObj.access_token);
    localStorage.setItem("refresh_token", tokenObj.refresh_token);
  }
  function _getUserData() {
    const userData = !!JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")) : {};
    return userData;
  }
  function _getTcUserData() {
    const userData = !!JSON.parse(localStorage.getItem("tcUserData")) ? JSON.parse(localStorage.getItem("tcUserData")) : {};
    return userData;
  }
  function _getExpiryDate() {
    const expiryDate =
      !!JSON.parse(localStorage.getItem("userData")) &&
      !!JSON.parse(localStorage.getItem("userData")).session_expiry_date &&
      JSON.parse(localStorage.getItem("userData")).session_expiry_date !== ""
        ? JSON.parse(localStorage.getItem("userData")).session_expiry_date
        : "";
    return expiryDate;
  }
  function _getUserProduct() {
    const currentProduct =
      !!JSON.parse(localStorage.getItem("userData")) &&
      !!JSON.parse(localStorage.getItem("userData")).current_product &&
      JSON.parse(localStorage.getItem("userData")).current_product !== ""
        ? JSON.parse(localStorage.getItem("userData")).current_product
        : "";
    return currentProduct;
  }
  function _getUserRpsPlanDetails() {
    const currentProduct =
      !!JSON.parse(localStorage.getItem("userRpsPlanDetails")) &&
      !!JSON.parse(localStorage.getItem("userRpsPlanDetails")) &&
      JSON.parse(localStorage.getItem("userRpsPlanDetails")) !== ""
        ? JSON.parse(localStorage.getItem("userRpsPlanDetails"))
        : "";
    return currentProduct;
  }
  function _getOptionId() {
    const currentOptionId =
      !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).option_id && JSON.parse(localStorage.getItem("userData")).option_id !== ""
        ? JSON.parse(localStorage.getItem("userData")).option_id
        : "";
    return currentOptionId;
  }
  function _getNavigate() {
    const navigate =
      !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).navigate && JSON.parse(localStorage.getItem("userData")).navigate !== ""
        ? JSON.parse(localStorage.getItem("userData")).navigate
        : "";
    return navigate;
  }
  function _getExpiryStatus() {
    const currentExpireStatus =
      !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).isExpired && JSON.parse(localStorage.getItem("userData")).isExpired !== ""
        ? JSON.parse(localStorage.getItem("userData")).isExpired
        : "";
    return currentExpireStatus;
  }
  function _getAccessToken() {
    const ssoToken =
      !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).sso_token && JSON.parse(localStorage.getItem("userData")).sso_token !== ""
        ? JSON.parse(localStorage.getItem("userData")).sso_token
        : "";
    return ssoToken;
  }
  function _getUserCurrentPlan() {
    const userCurrentPlan =
      !!JSON.parse(localStorage.getItem("userCurrentPlan")) &&
      !!JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan &&
      JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan !== ""
        ? JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan
        : "";
    return userCurrentPlan;
  }
  function _getUserDetails() {
    const userDetails =
      !!JSON.parse(localStorage.getItem("userDetails")) && !!JSON.parse(localStorage.getItem("userDetails")) !== "" ? JSON.parse(localStorage.getItem("userDetails")) : "";
    return userDetails;
  }
  function _getUserArrivalDate() {
    const userArrivalDate =
      !!JSON.parse(localStorage.getItem("user_arrival_date")) &&
      !!JSON.parse(localStorage.getItem("user_arrival_date")).userArrivalDate &&
      JSON.parse(localStorage.getItem("user_arrival_date")).userArrivalDate !== ""
        ? JSON.parse(localStorage.getItem("user_arrival_date")).userArrivalDate
        : "";
    return userArrivalDate;
  }
  function _getUserArrivalDateSetTime() {
    const userArrivalDateTime =
      !!JSON.parse(localStorage.getItem("user_arrival_date")) &&
      !!JSON.parse(localStorage.getItem("user_arrival_date")).setTime &&
      JSON.parse(localStorage.getItem("user_arrival_date")).setTime !== ""
        ? JSON.parse(localStorage.getItem("user_arrival_date")).setTime
        : "";
    return userArrivalDateTime;
  }
  function _getUserMexicoArrivalDate() {
    const userArrivalDate =
      !!JSON.parse(localStorage.getItem("user_mexico_arrival_date")) &&
      !!JSON.parse(localStorage.getItem("user_mexico_arrival_date")).userArrivalDate &&
      JSON.parse(localStorage.getItem("user_mexico_arrival_date")).userArrivalDate !== ""
        ? JSON.parse(localStorage.getItem("user_mexico_arrival_date")).userArrivalDate
        : "";
    return userArrivalDate;
  }
  function _getUserMexicoArrivalDateSetTime() {
    const userArrivalDateTime =
      !!JSON.parse(localStorage.getItem("user_mexico_arrival_date")) &&
      !!JSON.parse(localStorage.getItem("user_mexico_arrival_date")).setTime &&
      JSON.parse(localStorage.getItem("user_mexico_arrival_date")).setTime !== ""
        ? JSON.parse(localStorage.getItem("user_mexico_arrival_date")).setTime
        : "";
    return userArrivalDateTime;
  }
  function _getSessionID() {
    const sessionId =
      !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).session_id && JSON.parse(localStorage.getItem("userData")).session_id !== ""
        ? JSON.parse(localStorage.getItem("userData")).session_id
        : "";
    return sessionId;
  }
  function _getSessionExpiryDate() {
    const session_expiry_date =
      !!JSON.parse(localStorage.getItem("userData")) &&
      !!JSON.parse(localStorage.getItem("userData")).session_expiry_date &&
      JSON.parse(localStorage.getItem("userData")).session_expiry_date !== ""
        ? JSON.parse(localStorage.getItem("userData")).session_expiry_date
        : "";
    return session_expiry_date;
  }

  function _getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }
  function _clearToken() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }
  function _clearCompleteStorage() {
    localStorage.clear();
  }
  // Below Method is used CTA's
  function _clearFromPath() {
    localStorage.removeItem("from_path");
  }
  function _getFromPath() {
    const tempFromPath =
      !!JSON.parse(localStorage.getItem("from_path")) && !!JSON.parse(localStorage.getItem("from_path")).path && JSON.parse(localStorage.getItem("from_path")).path !== ""
        ? JSON.parse(localStorage.getItem("from_path")).path
        : "";
    return tempFromPath;
  }
  // End of the above Code
  //  Below code is for get the Reload Saved Search Data
  function _getReloadSavedSearchData() {
    const userDetails =
      !!JSON.parse(localStorage.getItem("reloadSavedSearch")) && !!JSON.parse(localStorage.getItem("reloadSavedSearch")) !== ""
        ? JSON.parse(localStorage.getItem("reloadSavedSearch"))
        : "";
    return userDetails;
  }
  function _clearReloadSavedSearchData() {
    localStorage.removeItem("reloadSavedSearch");
  }
  //  End of the above code
  return {
    getService: _getService,
    getUserData: _getUserData,
    getTcUserData: _getTcUserData,
    setToken: _setToken,
    getOptionId: _getOptionId,
    getNavigate: _getNavigate,
    getExpiryStatus: _getExpiryStatus,
    getUserProduct: _getUserProduct,
    getAccessToken: _getAccessToken,
    getUserCurrentPlan: _getUserCurrentPlan,
    getUserDetails: _getUserDetails,
    getUserArrivalDate: _getUserArrivalDate,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    getSessionID: _getSessionID,
    setDataToLocalStorage: setDataToLocalStorage,
    clearCompleteStorage: _clearCompleteStorage,
    getSessionExpiryDate: _getSessionExpiryDate,
    clearFromPath: _clearFromPath,
    getFromPath: _getFromPath,
    getExpiryDate: _getExpiryDate,
    getUserArrivalDateSetTime: _getUserArrivalDateSetTime,
    getReloadSavedSearchData: _getReloadSavedSearchData,
    clearReloadSavedSearchData: _clearReloadSavedSearchData,
    getUserMexicoArrivalDate: _getUserMexicoArrivalDate,
    getUserMexicoArrivalDateSetTime: _getUserMexicoArrivalDateSetTime,
    getUserRpsPlanDetails: _getUserRpsPlanDetails,
  };
})();
export default LocalStorageService;
